__turbopack_context__.v({
  "icon-root": "g0MQgW_icon-root",
});
